<template>
	<div class="page">
		<!-- 图片 -->
		<el-image class="pbg" :src="require('@/static/icon1.jpg')"></el-image>
		<!-- 注册 -->
		<div class="regBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="backPage jts" @click="link('/home')">返回网站首页</div>
			<div class="tips">已有账号<p @click="link('/login')">立即登录</p></div>
			<!-- 用户基本信息 -->
			<div class="userFrom">
				<div class="tit">找回密码</div>
				
				<!-- <div class="fromItm">
					<div class="name">选择身份<span> *</span></div>
					<div class="identity f-ct">
						<div class="itm f-ct" @click="userType=1" :class="userType==1?'a':''">
							<el-image v-if="userType==1" :src="require('@/static/icon3h.png')"></el-image>
							<el-image v-else :src="require('@/static/icon3.png')"></el-image>
							<p>学员用户</p>
						</div>
						<div class="itm f-ct" @click="userType=2" :class="userType==2?'a':''">
							<el-image v-if="userType==2" :src="require('@/static/icon4h.png')"></el-image>
							<el-image v-else :src="require('@/static/icon4.png')"></el-image>
							<p>企业用户</p>
						</div>
					</div>
				</div> -->
				
				<div class="fromItm">
					<div class="name">登录账号</div>
					<div class="iptBox">
						<el-input type="text" v-model="mobile" placeholder="请输入手机号"></el-input>
					</div>
				</div>
				<!-- <div class="fromItm">
					<div class="name">手机号码</div>
					<div class="imgCode f-ct">
						<div class="iptBox">
							<el-input type="number" v-model="mobile" placeholder="请输入手机号"></el-input>
						</div>
						<el-image :src="require('@/static/img2.png')"></el-image>
						<p>换一张</p>
					</div>
				</div>
				<div class="fromItm">
					<div class="name">手机号码</div>
					<div class="iptBox">
						<el-input type="number" v-model="mobile" placeholder="请输入注册时填写手机号"></el-input>
					</div>
				</div> -->
				<div class="fromItm">
					<div class="name">手机验证码</div>
					<div class="iptBox f-ct">
						<el-input type="text" class="codeIpt" v-model="code" placeholder="请输入验证码"></el-input>
						<div class="codeTxt" @click="authMemberregCaptcha">{{codetxt}}</div>
					</div>
				</div>
				<div class="fromItm">
					<div class="name">设置新的密码</div>
					<div class="iptBox">
						<el-input type="password" v-model="password" placeholder="输入新的密码"></el-input>
					</div>
				</div>
				<!-- <div class="fromItm">
					<div class="name">确认新的密码</div>
					<div class="iptBox">
						<el-input type="password" v-model="mobile" placeholder="确认新的密码"></el-input>
					</div>
				</div> -->
				<div class="anniu" @click="authMemberrestPassword">提交</div>
			</div>
		</div>
		<!-- 底部文字 -->
		<div class="baTxt">Copright @2017 Corporation AII Rights Reservde 琼ICP备18003071号-2 海南省燃气协会网支持IPv6网络</div>
	</div>
</template>
<script>
import { authMemberrestPassword,
authMemberregCaptcha,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
let ic;
var nub = 120;
export default {
	data(){
		return {
			userType:1,
			mobile:'',
			code:'',
			password:'',
			codetxt:'发送验证码',
		}
	},
	mounted() {
		
	},
	methods:{
		// 重置密码
		async authMemberrestPassword(){
			let res;
			if(this.userType==1){
				res = await authMemberrestPassword({
					code:this.code,
					mobile:this.mobile,
					password:this.password,
				});
			}
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.back()
			}else{this.Tips(res.msg,'error')}
		},
		// 验证码
		async authMemberregCaptcha(){
			var that = this
			if(!this.checkModbile(this.mobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			let res = await authMemberregCaptcha({mobile:this.mobile});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				ic = setInterval(()=>{
					nub--
					that.codetxt = nub+'s'
					if(nub<=0){
						that.codetxt = '发送验证码'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		checkModbile(mobile) {
			var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
			var result = re.test(mobile); 
			if(!result) {
				return false;//若手机号码格式不正确则返回false
				}
			return true;
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
	// padding-top: 140px;
	// padding-bottom: 140px;
	// padding-top: 60px;
}
</style>
<style lang="scss" scoped>
.identity{
				display: flex;
				justify-content: space-between;align-items: center;
				margin: auto;
				// margin-bottom: 20px;
				width: 350px;
				.itm{
					width: 170px;
					height: 72px;
					justify-content: center;
					border: 1px solid #DEDEDE;
					cursor: pointer;
					.el-image{
						width: 40px;
						height: 40px;
						margin-right: 12px;
					}
					text{
						font-size: 14px;
						color: #666666;
					}
				}
				.a{
					border: 1px solid #3B6492;
					text{
						color: #3B6492;
					}
				}
			}
.page{
	position: relative;
	padding-bottom: 140px;
	padding-top: 60px;
}
.pbg{
	width: 1920px;
	height: 1080px;
	display: block!important;
	position: fixed;
	top: 0;
	left: 0;
}
.regBox{
	// position: fixed;
	// top: 50%;
	// left: 50%;
	// transform: translateY(-50%)translateX(-50%);
	position: relative;
	z-index: 3;
	margin: auto;
	// margin-top: 60px;
	background: #fff;
	width: 1000px;
	// min-height: 810px;
	padding-bottom: 101px;
	.backPage{
		position: absolute;
		left: 4px;
		top: -32px;
		color: #3B6492;
		text-decoration: underline;
		font-size: 14px;
	}
	.tips{
		font-size: 14px;
		text-align: center;
		
		position: absolute;
		right: 4px;
		top: -32px;
		p{
			color: #3B6492;
			padding-left: 4px;
			display: inline-block;
			cursor: pointer;
		}
	}
	.userFrom{
		// background: #fff;
		.tit{
			font-size: 24px;
			color: #333333;
			text-align: center;
			padding-top: 62px;
			padding-bottom: 41px;
		}
		.fromItm{
			width: 350px;
			margin: auto;
			margin-bottom: 24px;
			.name{
				color: #666666;
				font-size: 14px;
				padding-bottom: 6px;
				span{
					color: #FF5F5A;
				}
			}
			.imgCode{
				height: 40px;
				.iptBox{
					// width: calc(100% - );
					.el-input{
						width: 100%;
					}
				}
				.el-image{
					width: 90px;
					height: 40px;
					margin: 0 10px;
				}
				p{
					font-size: 14px;
					color: #3B6492;
					cursor: pointer;
				}
			}
			.codeIpt{
				width: calc(100% - 96px)!important;
			}
			.iptBox{
				border: 1px solid #DDDDDD;
				padding-right: 6px;
				.el-input{
					// width: calc(100% - 96px);
					width: 100%;
				}
				::v-deep .el-input__inner{
					height: 40px;
					border: none;
					background: transparent;
				}
				.codeTxt{
					width: 96px;
					height: 28px;
					line-height: 28px;
					text-align: center;
					font-size: 12px;
					color: #3B6492;
					background: #E6F2FF;
					cursor: pointer;
				}
			}
		}
		.anniu{
			margin: auto;
			width: 182px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			font-size: 16px;
			color: #fff;
			background: #3B6492;
			cursor: pointer;
			margin-top: 34px;
		}
	}
}
</style>